import { DraftInvoiceStatus, DraftInvoiceSortBy, GetDraftInvoicesParams, getDraftInvoices } from '@/ar/network/AccountsReceivable.network';

export type NextDraftParams = {
    invoiceID: string,
    supplierID: string,
    searchParams: Partial<GetDraftInvoicesParams> & { limit?: number, page?: number },
};

export async function getNextDraftInvoiceIdForPublish({ invoiceID, supplierID, searchParams }: NextDraftParams): Promise<string | null> {
    const limit = searchParams?.limit ?? 20;
    const page = searchParams?.page ?? 0;
    const sortBy = (searchParams?.sort_by ?? '-created_at') as DraftInvoiceSortBy;

    const baseParams: GetDraftInvoicesParams = {
        ...searchParams,
        status: [DraftInvoiceStatus.Draft],
        supplier_id: supplierID,
        limit,
        offset: page * limit,
        sort_by: sortBy,
    } as GetDraftInvoicesParams;

    const currentPage = await getDraftInvoices(baseParams);
    const currentIndex = currentPage?.invoices?.findIndex((inv) => inv.id === invoiceID);

    if (currentIndex !== -1 && currentIndex + 1 < (currentPage?.invoices?.length ?? 0)) {
        return currentPage.invoices[currentIndex + 1].id;
    }

    const nextPage = await getDraftInvoices({ ...baseParams, offset: (page + 1) * limit });
    return nextPage?.invoices?.[0]?.id ?? null;
}
